// extracted by mini-css-extract-plugin
export default {"container":"AboutHero_container__UXEGt"};